import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import type { Project } from '../../../data/projects';
interface ProjectDirectoryProps {
  projects: Project[];
  activeIndex: number;
  reduceMotion: boolean;
  onSelect: (index: number) => void;
}
export function ProjectDirectory({
  projects,
  activeIndex,
  reduceMotion,
  onSelect
}: ProjectDirectoryProps) {
  const scrollerRef = useRef<HTMLElement>(null);

  // On narrow screens the directory scrolls sideways; keep the active project in view
  // without touching the page's vertical scroll position.
  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;
    const active = scroller.querySelector<HTMLElement>('[aria-current="true"]');
    if (!active) return;
    const item = active.parentElement ?? active;
    scroller.scrollTo({
      left: item.offsetLeft - scroller.clientWidth / 2 + item.clientWidth / 2,
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  }, [activeIndex, reduceMotion]);
  return <nav ref={scrollerRef} aria-label="Project directory" className="relative -mx-5 overflow-x-auto px-5 sm:-mx-6 sm:px-6 md:-mx-10 md:px-10 lg:-mx-14 lg:px-14" style={{
    scrollbarWidth: 'none'
  }} data-id="element-220" data-mp="cd1ktt5gqsby">
      <ol className="flex w-max min-w-full justify-between gap-x-8 lg:gap-x-10" style={{
      borderBottom: '1px solid var(--border)'
    }} data-id="element-221" data-mp="3ul0sxgm4wj7o">
        {projects.map((project, i) => {
        const isActive = i === activeIndex;
        return <li key={project.id} className="relative flex-shrink-0" data-id="element-222" data-mp="3ktmkgjc7g92e" data-mpi={i}>
              <button type="button" onClick={() => onSelect(i)} aria-current={isActive ? 'true' : undefined} className="flex w-full flex-col items-start gap-1.5 bg-transparent pb-5 text-left transition-opacity duration-150 ease-out" style={{
            opacity: isActive ? 1 : 0.45
          }} onMouseEnter={e => {
            if (!isActive) e.currentTarget.style.opacity = '0.75';
          }} onMouseLeave={e => {
            if (!isActive) e.currentTarget.style.opacity = '0.45';
          }} data-id="element-223" data-mp="3fwnvef7eesb2">
                <span className="flex h-8 items-center" data-id="element-224" data-mp="2ice8laq15om6">
                  {project.logo ? <img src={project.logo} alt={project.name} className="pointer-events-none select-none" style={{
                height: 22,
                width: 'auto',
                filter: 'brightness(0)'
              }} draggable={false} data-id="element-225" data-mp="2n9mp76vj5klb" /> : <span className="font-aspekta whitespace-nowrap text-base tracking-tight lg:text-lg" style={{
                color: 'var(--fg)'
              }} data-id="element-226" data-mp="367qn155yvx7t">
                      {project.name}
                    </span>}
                </span>
                <span className="whitespace-nowrap text-sm leading-snug" style={{
              color: 'var(--muted)'
            }} data-id="element-227" data-mp="1n8ss8ozuv7k2">
                  {project.tagline}
                </span>
              </button>
              {isActive && <motion.span layoutId="project-directory-marker" className="absolute -bottom-px left-0 right-0 h-[2px]" style={{
            background: 'var(--accent)'
          }} transition={{
            duration: reduceMotion ? 0 : 0.25,
            ease: [0.23, 1, 0.32, 1]
          }} aria-hidden="true" data-id="element-228" data-mp="1wy2kq5ym2s8p" />}
            </li>;
      })}
      </ol>
    </nav>;
}